import { AlertModalModel } from "../../../models/AlertModal.model";
import { AlertDispatchType, SET_ALERT } from "../../actions/alert/AlertActionType";

interface IDefaultState {
    alert: AlertModalModel
}

const defaultState: IDefaultState = {
    alert: {
        type: "error",
        btnText: "retry",
        message: "action_failed",
        title: "action_failed",
        show: false,
    }
};

const AlertReducer = (
    // eslint-disable-next-line no-restricted-globals
    state: IDefaultState = defaultState,
    action: AlertDispatchType
): IDefaultState => {
    switch (action.type) {
        case SET_ALERT:
            return {
                ...state,
                alert: action.payload.alert
            };
        default:
            return state;
    }
};

export default AlertReducer;
